module.exports = __webpack_public_path__ + "static/media/GC01@s.cab155a0.jpg";